import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    Input,
    SimpleChanges
} from "@angular/core";
import ReactDOM from "react-dom";
import React from "react";
import styled from "@emotion/styled";
import { SelectField } from "@dfds-ui/react-components";
import { SelectItem } from './select.model';
import { FormControl } from '@angular/forms';

const SelectFieldStyled = styled(SelectField)`
    select {
        background: none;
        padding-left: 15p;
        padding-right: 50px;
        padding-top: 0px;
        padding-bottom: 0px;
        border-radius: 0;
    }

    svg {
        color: rgb(107, 178, 226);
    }
`

const ifNull = (val, nullValue) => val == null ? nullValue : val

@Component({
    selector: "sbw-select-field",
    template: "<div #react></div>"
})
export class SelectFieldComponent implements OnInit {
    @ViewChild("react", { static: true }) react: ElementRef;

    @Input() name: string;
    @Input() label: string;
    @Input() control: FormControl;
    @Input() items: SelectItem[];
    @Input() errorMessage: string;

    ngOnInit() {
        this.control.valueChanges.subscribe(() => {
            this.validate()
            this.render()
        })
        this.validate()
        this.render()
    }

    render() {
        // If label contains _ we set the &nbsp; for non breaking space
        const getLabel = () => this.label == "_" ? <span>&nbsp;</span> : this.label
        const onChange = (data) => { this.control.setValue(data.target.value) }

        // Added shared className to remove styles that should not overwrite the shared component styles
        ReactDOM.render(
            <SelectFieldStyled className="shared" name={this.name} label={getLabel()} value={ifNull(this.control && this.control.value, '')} onChange={onChange} errorMessage={this.errorMessage}>
                {this.items.map(i => <option key={i.value} value={i.value}>{i.text}</option>)}
            </SelectFieldStyled>,
            this.react.nativeElement
        );
    }

    ngOnChanges(s: SimpleChanges) {
        if (s.items && !s.items.firstChange) this.validate()
        this.render()
    }

    private validate() {
        if (!this.items.some(i => i.value == this.control.value)) {
            const newValue = ifNull(this.items[0] && this.items[0].value, '')
            this.control.setValue(newValue);
        }
    }
}
